import React, {useEffect, useState} from "react";
import {Navigation} from "@/components/Navigation";
import {Footer} from "@/components/Footer";
import {Button} from "@/components/ui/button";
import {Input} from "@/components/ui/input";
import {Form, FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
import {useForm} from "react-hook-form";
import {useNavigate, useSearchParams} from "react-router-dom";
import {toast} from "sonner";
import supabase from "../utils/supabaseClient.ts";
import {EmailOtpType} from "@supabase/supabase-js";
import {SEO} from "@/components/SEO.tsx";

interface UpdateFormValues {
    password: string;
}

const Recover = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const token_hash = searchParams.get("token_hash");
    const type = searchParams.get("type");
    const form = useForm<UpdateFormValues>({
        defaultValues: {
            password: "",
        },
    });

   /* useEffect(() => {
        // console.log(token_hash)

    }, [searchParams]);*/
    const onSubmit = async (loginFormValues: UpdateFormValues) => {
        setIsLoading(true);
        if (!loginFormValues.password) {
            return toast.error('Please check your new password.');
        }

        try {

            // const url = `${import.meta.env.VITE_API_URL}/users/recover?token_hash=${token_hash}&type=${type}&password=${loginFormValues.password}`;
            const url = `${import.meta.env.VITE_API_URL}/users/recover`;
            const headers = {
                'Content-Type': 'application/json',
            };
            const body = JSON.stringify({token_hash,type,password: loginFormValues.password});

            const response = await fetch(url, {
                method: 'POST',
                headers,
                body,
            });
            // const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const responseData = await response.json();

            // console.log("responseData:",responseData)
            if(responseData.error)
                return toast.error(responseData.error);
            toast.success('Password updated successfully!');
            setTimeout(()=>{
                navigate("/login");
            },1000);
        } catch (err) {
            // console.error('Update error:', err);
            toast.error('An error occurred.');
        }

        setIsLoading(false);
    };

    return (
        <div className="min-h-screen bg-white font-sans dark:bg-background">
            <SEO
                title="Recover"
                description="Complete your password reset process and get back into your account"
                type="website"
                name="blankpoll"
                imageUrl="/blankpoll-banner.jpg"
            />
            <Navigation/>
            <div className="container max-w-md mx-auto pt-24 px-4">
                <div className="bg-white p-8 rounded-lg border border-gray-200 dark:bg-gray-800/50 dark:border-gray-700">
                    <h2 className="text-2xl font-bold text-center mb-6">Update Password</h2>
                    <Form {...form}>
                        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
                            <FormField
                                control={form.control}
                                name="password"
                                render={({field}) => (
                                    <FormItem>
                                        <FormLabel>New Password</FormLabel>
                                        <FormControl>
                                            <Input placeholder="Enter your new password" type="password" {...field}
                                                   autoComplete={"off"} className="dark:bg-gray-700 dark:text-white dark:border-gray-600"/>
                                        </FormControl>
                                        <FormMessage/>
                                    </FormItem>
                                )}
                            />
                            <Button className="w-full text-white dark:bg-[#2C3930] dark:hover:bg-[#2C3930]/90" type="submit" disabled={isLoading}>
                                {isLoading ? "Processing..." : "Update"}
                            </Button>
                        </form>
                    </Form>
                </div>
            </div>
            <Footer/>
        </div>
    )
        ;
};

export default Recover;
